import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { MessageModal } from '../../components/modals/MessageModal';
export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [isMessageModalOpen, setIsMessageModalOpen] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsMessageModalOpen(true);
  };
  return <div className="min-h-screen bg-[#f5f5f7] font-sans text-[#1f2933]" data-id="element-2224">
      <header className="bg-white border-b border-gray-300 py-4 px-6 md:px-12" data-id="element-2225">
        <Link to="/" className="flex items-center gap-2" data-id="element-2226">
          <div className="w-8 h-8 bg-[#1f2933] rounded-sm" data-id="element-2227"></div>
          <span className="font-bold text-xl tracking-tight" data-id="element-2228">
            Citiplots.com
          </span>
        </Link>
      </header>

      <main className="max-w-md mx-auto px-4 py-12" data-id="element-2229">
        <div className="bg-white border border-gray-300 p-8 shadow-sm" data-id="element-2230">
          <h1 className="text-2xl font-bold mb-2" data-id="element-2231">Reset Password</h1>
          <p className="text-sm text-gray-500 mb-6" data-id="element-2232">
            Enter your email address and we'll send you a reset link
          </p>

          <form onSubmit={handleSubmit} className="space-y-4" data-id="element-2233">
            <div data-id="element-2234">
              <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-2235">
                Email Address
              </label>
              <input type="email" required value={email} onChange={e => setEmail(e.target.value)} className="w-full p-2 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500" data-id="element-2236" />
            </div>

            <button type="submit" className="w-full py-3 bg-[#1f2933] text-white font-bold hover:bg-gray-800" data-id="element-2237">
              Send Reset Link
            </button>
          </form>

          <p className="mt-6 text-center text-sm text-gray-600" data-id="element-2238">
            Remember your password?{' '}
            <Link to="/auth/signin" className="text-blue-600 font-bold hover:underline" data-id="element-2239">
              Sign In
            </Link>
          </p>
        </div>
      </main>

      <MessageModal isOpen={isMessageModalOpen} onClose={() => setIsMessageModalOpen(false)} title="Reset Link Sent" message={`Password reset instructions have been sent to ${email}. Please check your inbox and spam folder.`} type="success" data-id="element-2240" />
    </div>;
}